module.exports = __webpack_public_path__ + "static/img/uj-en.7ef8cb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uj-en.svg
// module id = PQkP
// module chunks = 1